import TextTicker from './TextTicker';

export default TextTicker;
